// 구성 화면의 「다음:」 줄이 가리키는 탭을 탭 바에 알리는 통로
//
// 「다음:」 줄은 각 탭 안에서 계산되는데 탭 바는 그 바깥 껍데기가 그린다. 명부에 아군이 생겨
// 줄이 「ATTACK 탭에서 main 을 만듭니다」로 바뀌어도 ATTACK 탭은 다른 탭과 같은 무게라, 줄이
// 가리키는 곳과 눈에 띄는 곳이 달랐다(2026-10-12 대리 관측 두 판, 사용자가 D4 에서 당겨 옴).
//
// 탭 바 파일(`tabbar.tsx`)이 탭 화면들을 import 하므로, 이 통로를 거기 두면 탭 화면이 탭 바를
// 다시 import 하는 순환이 생긴다. 그래서 따로 둔다.

import { createContext, useContext, useEffect } from 'react'

export type ComposeCueTab = 'roster' | 'attack' | 'defense'

export const ComposeCueContext = createContext<((tab: ComposeCueTab | null) => void) | null>(null)

/**
 * 이 화면이 떠 있는 동안 탭 바에 `tab` 을 가리키게 한다. 화면이 내려가면 지운다. 그래서 강조는
 * 그 「다음:」 줄이 보이는 동안에만 선다. 통로가 없는 자리(단독 렌더 검사)에서는 아무 일도 없다.
 */
export function useComposeCue(tab: ComposeCueTab | null): void {
  const setCue = useContext(ComposeCueContext)
  useEffect(() => {
    if (setCue === null) return undefined
    setCue(tab)
    return () => {
      setCue(null)
    }
  }, [setCue, tab])
}
